module.exports = __webpack_public_path__ + "static/media/prev-video-disabled-icon.8f4cbb55.svg";